var elementInViewport = function(el) {
    var rect;

    if (typeof jQuery === 'function' && el instanceof jQuery) {
        el = el[0];
    }

    rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
};

module.exports = {
    showAlert: function(content) {
        $('body').append('<div class="alert">' + content + '</div>');
        $('#page-wrapper').addClass('presopen');

        setTimeout(function() {
            module.exports.hideAlert();
        }, 1000);
    },

    hideAlert: function() {
        $('.alert').fadeOut(400);
        $('#page-wrapper').removeClass('presopen');
    },

    contentToggle: function($element, enableSlideTo = false) {
        const minWidth = 920;

        var $window = $(window);

        $element.find('.content-toggle-item .content-toggle-header').each(function() {
            var $this = $(this);

            if ($this.parents('.content-toggle-item ').hasClass('only-mobile') && $window.width() >= minWidth) {
                return;
            }

            $(this).on('click', function(e) {
                var $toggleItem = $this.closest('.content-toggle-item'),
                    $toggleContent = $toggleItem.find('.content-toggle-content'),
                    wasOpened = $toggleItem.hasClass('opened');

                e.preventDefault();

                $('.content-toggle-item.opened:not(.toggle-stay)').removeClass('opened')
                    .find('.content-toggle-content').slideUp(200);

                if (!wasOpened) {
                    $toggleItem.addClass('opened');
                    $toggleContent.slideDown(200, function() {
                        if (enableSlideTo) {
                            module.exports.slideTo($toggleItem);
                        }
                    });
                } else {
                    $toggleItem.removeClass('opened');
                    $toggleContent.slideUp(200);
                }
            });
        });
    },

    slideTo: function(element, offset = 50, callback = null) {
        var $el = (typeof element === 'string') ? $(element) : element;

        $('html, body').stop(true, true).animate({
            scrollTop: $($el).offset().top - offset
        }, 500, 'swing', function() {
            if (callback !== null) {
                callback();
            }
        });
    },

    isVisible: function(elem) {
        if (!(elem instanceof Element || elem instanceof HTMLDocument)) {
            return false;
        }
        const style = getComputedStyle(elem);
        if (style.display === 'none') {
            return false;
        }
        if (style.visibility !== 'visible') {
            return false;
        }
        if (style.opacity < 0.1) {
            return false;
        }
        if (elementInViewport(elem) === false) {
            return false;
        }
        if ($(elem).outerWidth(true) + $(elem).outerHeight(true) + elem.getBoundingClientRect().height +
            elem.getBoundingClientRect().width === 0) {
            return false;
        }
        const elemCenter = {
            x: elem.getBoundingClientRect().left + $(elem).outerWidth(true) / 2,
            y: elem.getBoundingClientRect().top + $(elem).outerHeight(true) / 2
        };
        if (elemCenter.x < 0) {
            return false;
        }
        if (elemCenter.x > (document.documentElement.clientWidth || window.innerWidth)) {
            return false;
        }
        if (elemCenter.y < 0) {
            return false;
        }
        if (elemCenter.y > (document.documentElement.clientHeight || window.innerHeight)) {
            return false;
        }

        return true;
    },

    elementInViewport: elementInViewport
};
